import { render, staticRenderFns } from "./ModalExclusionDepartment.vue?vue&type=template&id=76d489ee&scoped=true&"
import script from "./ModalExclusionDepartment.vue?vue&type=script&lang=ts&"
export * from "./ModalExclusionDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalExclusionDepartment.vue?vue&type=style&index=0&id=76d489ee&lang=scss&scoped=true&"
import style1 from "./ModalExclusionDepartment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d489ee",
  null
  
)

export default component.exports